import { fokaAxios } from 'app/fokaAxios'
import { upload } from 'api/axios/tenth'

const { get, post, put } = fokaAxios
export default {
  getDownload: (page = 0, limit = 20) =>
    get('/api/v2/massive/download', {
      params: {
        page,
        limit,
        sort: 'createdDate desc',
      },
    }),
  postCreativeDownload: massiveDownloadRequestCommand =>
    post('/api/v2/massive/download/creative', massiveDownloadRequestCommand),
  postCampaignDownload: massiveDownloadRequestCommand =>
    post('/api/v2/massive/download/campaign', massiveDownloadRequestCommand),
  getDownloadFile: massiveId =>
    get(`/api/v2/massive/download/${massiveId}/downloadurl`),
  cancelDownload: massiveId =>
    put(`/api/v2/massive/download/cancel/${massiveId}`),
  getUpload: (page = 0, limit = 20) =>
    get('/api/v2/massive/upload', {
      params: {
        page,
        limit,
        sort: 'createdDate desc',
      },
    }),
  postUpload: massiveUploadRequestCommand =>
    post('/api/v2/massive/upload', massiveUploadRequestCommand),
  getUploadFile: massiveId =>
    get(`/api/v2/massive/upload/${massiveId}/downloadurl`),
  cancelUpload: massiveId => put(`/api/v2/massive/upload/cancel/${massiveId}`),
  uploadFile: file =>
    upload('/api/v2/files/private-upload-url', file, {
      type: 'MASSIVE_UPLOAD',
      filename: file.name,
    }),
  getAllTemplateFile: () => get('/api/v2/massive/upload/template?type=ALL'),
  getTemplateFile: type =>
    get('/api/v2/massive/upload/template', {
      params: { type },
    }),
  getKeywordPlanner: (page = 0, limit = 20) =>
    get('/api/v2/massive/keywordplanner', {
      params: {
        page,
        limit,
        sort: 'createdDate desc',
      },
    }),
  postKeywordPlanner: massiveKeywordPlannerRequestCommand =>
    post('/api/v2/massive/keywordplanner', massiveKeywordPlannerRequestCommand),
  getKeywordPlannerFile: massiveId =>
    get(`/api/v2/massive/keywordplanner/${massiveId}/downloadurl`),
  cancelKeywordPlanner: massiveId =>
    put(`/api/v2/massive/keywordplanner/cancel/${massiveId}`),
  getKeywordTemplateFile: () => get('/api/v2/massive/keywordplanner/template'),
  getAdGroupCopyHistory: (page = 0, size = 20) =>
    get('/api/v2/adgroups/copy/histories', {
      params: {
        page,
        size,
      },
    }),
  putAdGroupCopyRetry: adGroupId =>
    put(`/api/v2/adgroups/${adGroupId}/copy/retry`),
}
